module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/forecastquery-2018-06-26.paginators.json
// module id = 589
// module chunks = 0